<section class="max-w-[1320px] mx-auto px-4 sm:px-6 lg:px-10 py-8 sm:py-10 animate-fade-in relative z-10 pb-20 sm:pb-24 overflow-x-hidden">

  @if (loading()) {
    <div class="card p-6 sm:p-10 rounded-[20px] bg-[#0c0c0c]/80 border border-white/[0.05] text-center">
      <p class="text-text-muted text-[14px]">Loading page content...</p>
    </div>
  } @else if (content(); as page) {

    <!-- Header -->
    <div class="mb-8 sm:mb-10">
      <span
        class="inline-block text-gold text-[10px] sm:text-xs uppercase tracking-widest font-extrabold bg-gold/10 px-3 py-1.5 rounded-full border border-gold/25">
        Legal
      </span>
      <h1 class="font-display font-black text-[28px] sm:text-[36px] md:text-[44px] text-white tracking-wide mt-3 sm:mt-4 mb-2 break-words leading-tight">
        {{ page.title }}
      </h1>
      <p class="text-[13px] sm:text-[14px] text-text-muted max-w-2xl leading-relaxed break-words">{{ page.subtitle }}</p>
      <p class="text-[11px] sm:text-[12px] text-text-dim mt-2 sm:mt-3 font-medium">Last updated: {{ page.lastUpdated }}</p>
    </div>

    <!-- Intro -->
    <div
      class="card p-5 sm:p-6 md:p-8 rounded-[16px] sm:rounded-[20px] bg-[#0c0c0c]/80 border border-gold/20 shadow-[0_8px_30px_rgba(0,0,0,0.5)] mb-6 sm:mb-8">
      <p class="text-text-muted text-[13px] sm:text-[14.5px] leading-relaxed break-words">{{ page.intro }}</p>
    </div>

    <!-- Sections -->
    <div class="space-y-4 sm:space-y-5">
      @for (section of page.sections; track section.heading) {
        <div
          class="card p-5 sm:p-6 md:p-8 rounded-[16px] bg-[#0c0c0c]/80 border border-white/[0.05] hover:border-gold/15 transition-colors min-w-0">
          <h2 class="font-display font-bold text-white text-[16px] sm:text-[18px] tracking-wide mb-3 flex items-start gap-3">
            <span class="w-2 h-2 mt-2 rounded-full bg-gold shadow-[0_0_8px_rgba(245,183,59,0.6)] shrink-0"></span>
            <span class="min-w-0 flex-1 break-words leading-snug">{{ section.heading }}</span>
          </h2>
          <p class="text-[#999999] text-[13px] sm:text-[14px] leading-relaxed whitespace-pre-line break-words pl-0 sm:pl-5">{{ section.body }}</p>
        </div>
      }
    </div>
  }

</section>
